import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class ViaCepService {
  constructor(private httpClient: HttpClient) {}

  public getAdressbyPostalCode(
    postalCode: string,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `https://viacep.com.br/ws/${postalCode.replace(/\D/g, '')}/json/`,
    )
  }
}
